var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.26735 7.62764C2.25911 7.63488 2.25104 7.64243 2.24317 7.65029C2.20133 7.69213 2.16846 7.73954 2.14455 7.79013C2.05514 7.97617 2.08756 8.20609 2.24178 8.36032C2.25504 8.37358 2.26886 8.38594 2.28317 8.3974L6.13226 12.2465C6.32752 12.4418 6.6441 12.4418 6.83937 12.2465C7.03463 12.0512 7.03463 11.7346 6.83937 11.5394L3.80003 8.50005H13.5C13.7762 8.50005 14 8.27619 14 8.00005C14 7.72391 13.7762 7.50005 13.5 7.50005H3.80916L6.83798 4.47123C7.03324 4.27597 7.03324 3.95938 6.83798 3.76412C6.64272 3.56886 6.32613 3.56886 6.13087 3.76412L2.26735 7.62764Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowLeft);
export default __webpack_public_path__ + "static/media/ic_arrow_left.a5d96b994199d45a1a553539191d19a2.svg";
export { ForwardRef as ReactComponent };